import { internalOnlyFields } from "@coreapp/constants";

const isInternalField = fieldName => {
  if (typeof fieldName !== "string") return false;

  if (fieldName.includes("_metrics_")) return true;

  return internalOnlyFields.includes(fieldName);
};

export const filterInternalFields = fieldList => {
  if (!Array.isArray(fieldList)) {
    return fieldList;
  }

  return fieldList.filter(field => {
    if (field == null) return false;

    if (typeof field === "string") {
      return !isInternalField(field);
    }
    return true;
  });
};

export const filterInternalFieldDefs = fieldDefList => {
  if (!Array.isArray(fieldDefList)) {
    return fieldDefList;
  }

  return fieldDefList.filter(fieldDef => {
    if (fieldDef) {
      const fieldName = fieldDef.GetFieldName();
      return !isInternalField(fieldName);
    }
    return true;
  });
};
